import { useLayoutEffect } from "react";

/**
 * Customer-facing public pages (order link, photo/moment upload) are branded,
 * light-only surfaces — the logo and UPI marks assume a white page. Force the
 * light palette while one is mounted, regardless of the admin's theme choice,
 * and restore it on the way out.
 */
export function useLightTheme(): void {
  useLayoutEffect(() => {
    const root = document.documentElement;
    const wasDark = root.classList.contains("dark");
    root.classList.remove("dark");
    return () => {
      if (wasDark) root.classList.add("dark");
    };
  }, []);
}
